import { Phone, Mail, MessageCircle } from 'lucide-react';
import { useTranslation } from '@/i18n';
import { useIsMobile } from '@/hooks/useMediaQuery';

export function Footer() {
  const { t } = useTranslation();
  const isMobile = useIsMobile();

  if (isMobile) return null; // Footer hidden on mobile; info in MobileMenu

  return (
    <footer className="fixed bottom-0 left-0 right-0 z-40 bg-brand-navy/95 backdrop-blur-sm border-t border-white/10">
      <div className="max-w-7xl mx-auto px-6 h-12 flex items-center justify-center gap-8 text-sm">
        <a
          href="tel:+37455065055"
          className="flex items-center gap-2 text-white/70 hover:text-brand-gold transition-colors"
        >
          <Phone size={14} />
          <span>{t('footer.phone')}: +374 55 065 055</span>
        </a>
        <a
          href="mailto:sales@pullmanyerevan.com"
          className="flex items-center gap-2 text-white/70 hover:text-brand-gold transition-colors"
        >
          <Mail size={14} />
          <span>sales@pullmanyerevan.com</span>
        </a>
        <a
          href="https://wa.me/37441788066"
          target="_blank"
          rel="noopener noreferrer"
          className="flex items-center gap-2 text-white/70 hover:text-brand-gold transition-colors"
        >
          <MessageCircle size={14} />
          <span>{t('footer.whatsapp')}</span>
        </a>
      </div>
    </footer>
  );
}
